import * as R from 'ramda'
import { createSelector } from 'reselect'

const ROUTER_PATH = ['router']
const PARAMS_PATH = [...ROUTER_PATH, 'queryParams']

export const routerSelector = R.pathOr({}, ROUTER_PATH)
export const queryParamsSelector = R.pathOr({}, PARAMS_PATH)

export const queryParamSelector = (param, defaultVal, transform) =>
  createSelector(queryParamsSelector, queryParams => {
    const value = R.pathOr(defaultVal, [param], queryParams)

    return transform ? transform(value) : value
  })
